
import gsap from 'gsap'
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import loadComponents from 'gia/loadComponents';
import config from 'gia/config';


import Cover from './cover'
import Slider from './slider'
import Issue from './issue'
import Roll from './roll'

// import Animation from './animation'
// import Slider from './slider'
// import Filmstrip from './filmstrip'

// import Articles from './articles'
 import Imagery from './imagery'
// import Partners from './partners'
// import Certificates from './certificates'

// import Events from './events'
// import Video from './video'
import lazySizes from 'lazysizes';
import owd from '../owd/owd';

import CustomCursor from './custom-cursor';
import CustomHover from './custom-hover';
import '../components/cursor-mode';
import '../components/cursor-hover';
import '../components/cursor-theme';


class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
    //  config.set('log', false); // disables unnecessary console.log calls

      const app = new owd.App();
      app.use('customCursor', CustomCursor);
      app.use('customHover', CustomHover);
      app.run();
  

      const components = {
         Cover:Cover,
         Slider: Slider, 
         Issue: Issue,
         Roll: Roll,
        // Animation: Animation,
        // Slider: Slider,
        // Filmstrip: Filmstrip,
        // Issue: Issue,
        // Articles: Articles,
         Imagery: Imagery
      }

     loadComponents(components)

     $('.loader__title').on('mouseenter', (e) => {
       
      $('body').addClass('overlay')
    })
    $('.loader__title').on('mouseleave', (e) => {
      
      $('body').removeClass('overlay')
    })

  
   
     
     console.log(sessionStorage.getItem("initialised"));
     
    // See if we have an autosave value
    // (this will only happen if the page is accidentally refreshed)
    //if (sessionStorage.getItem("initialised") != "true") {
      gsap.delayedCall(.1, () => {
        $('body').addClass('load')
         
       });
       gsap.delayedCall(2, () => {
         $('body').addClass('no-loader')
  
       });
       sessionStorage.setItem("initialised", 'true');
      
   // }
  //  else{
      
      
      // gsap.delayedCall(.1, () => {
      //   $('body').addClass('load initialised')
         
      //  });
      
      // $('body').addClass('no-loader')

  //  }
    
   


     

      $('.open-menu').on('click', (e) => {
        e.preventDefault()
        $('body').toggleClass('has-menu')
      })
    

    //  $('.open-cart').on('click', (e) => {
    //     e.preventDefault()
    //     $('body').addClass('has-cart')
    //  })
    //  $('.close-cart, .cart__bg ').on('click', (e) => {
    //    e.preventDefault()
    //    $('body').removeClass('has-cart')
    //  })

     $('#menuBtn').on('click', (e) => {
       e.preventDefault()
       $('body').toggleClass('has-menu')
     })


     $('.signup').on('click', (e) => {
       e.preventDefault()
       $('body').toggleClass('has-subscribe')
     })
     $('.signup-mobile').on('click', (e) => {
       e.preventDefault()
       $('body').toggleClass('has-subscribe')
       $('body').removeClass('has-menu')
       window.scrollTo(0, document.body.scrollHeight);
     })

    

     $('.close-signup').on('click', (e) => {
       e.preventDefault()
       $('body').removeClass('has-subscribe')

     })
     

    //  $('.menu a').on('click', (e) => {
    //    e.preventDefault()
    //    $('body').addClass('reloaded')

    //    $('.menu .active').removeClass('active')
    //    $(e.currentTarget).addClass('active')

    //    this.delayedCall = gsap.delayedCall(1, () => {
    //     $('body').removeClass(['reloaded', 'loaded'])
    //     window.location.href = $(e.currentTarget).attr('href')
        
         
    //    })

    //  })
 


  }


}

module.exports = App
